export enum NotificationsScreenNames {
  MAIN = 'notifications-nav',
  NOTIFICATIONS = 'notifications',
}
